module.exports = __webpack_public_path__ + "img/hamochi_sad.58303e15.png";